import * as React from 'react'
import Spinner from '../../components/Spinner'
import { Link, Redirect } from 'react-router-dom'

class ManageUsersScreen extends React.Component {

  componentDidMount() {
    const { state } = this.props.location
    if( state && state.userType )
      this.props.getUserListWithType(state.userType)
  }

  render() {
    const { state } = this.props.location
    if( !state ) return <Redirect to="/manageapp" />
    const { userType } = state,
          userList = this.props.users.userListWithType[userType]
    
    if( userList===null ) return <Spinner />
    return (
      <div>
        <Link 
          className="btn btn-primary btn-sm btn-block mb-3"
          to={{
            pathname: "manage-user-detail",
            user: { type: userType }
          }}
        >Dodaj {userType==='fisherman' ? 'rybaka' : 'restaurację'}</Link>

        <div className="list-group">
          {userList.map( (user, key) => (
            <Link 
              key={key}
              className="list-group-item"
              to={{
                pathname: 'manage-user-detail',
                user
              }}
            >
              {user.type === 'fisherman' ?
              <React.Fragment>
                { (user.firstName && user.firstName.length) || (user.lastName && user.lastName.length) ?
                <p className="m-0">{user.firstName} {user.lastName}</p>
                :
                <p className="m-0">Użytkownik {user.id}</p>
                }
                <span className="text-muted small">{user.shipNo ? `Kuter ${user.shipNo}` : null}</span>
              </React.Fragment>
              :
              <React.Fragment>
                {user.name && user.name.length ?
                <p className="m-0">Restauracja {user.name}</p>
                :
                <p className="m-0">Restauracja {user.id}</p>
                }
                { user.address && <span className="text-muted small">{user.address.replace(/<br\s*[/]?>( |)/gi, "\n")}</span>}
              </React.Fragment>
              }
            </Link>
          ))}
        </div>
      </div>
    )
  }
}


export default ManageUsersScreen



// WEBPACK FOOTER //
// ./src/screens/ManageUsers/ManageUsersScreen.js